module.exports = __webpack_public_path__ + "static/img/logo.062bc9cb.svg";